import React from "react";
import { StyledBookAVisitButton } from "../../../components/LayoutApp/LayoutApp.style";
import { useModal } from "../../../context/ModalContext";
import { MODALS } from "../../../config/params";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { getContactString } from "../../containers/ChangeHospitalContainer/ChangeHospitalContainer";

const CallHospitalModal = () => {
  const { openModal } = useModal();
  const { user } = useUserStore();

  const handleLogoutClick = () => {
    openModal(MODALS.LOGOUT);
  };

  const getLocationContact = ()=>{
    if (user) {
      if (user.location) {
        return getContactString(user.location.phoneNumber);
      }
    } else {
      return "";
    }
  };

  return (
    <div className="h-full p-3">
      <div className="h-full flex flex-col items-center gap-4">
        <div className="flex-1 flex flex-col gap-4 w-full">
          <div className="flex flex-col items-center gap-4">
            <div className="text-2xl font-semibold">Call Hospital</div>
            <div className="text-base px-2 text-center">
              <span>We are currently not taking mobile bookings for this location. Please call the hospital at{" "}
                <a href={getLocationContact()}
                  className="underline text-gv-yellow cursor-pointer">{user?.location?.phoneNumber}</a>{" "}
                to book your appointment.
              </span>
            </div>
          </div>
          <div className="bg-white rounded-lg">
            <img src={user?.location?.background} className="object-cover h-36 w-full rounded-t-lg" />
            <div className="p-3">
              <div className="text-xl font-semibold">{user?.location?.locationName}</div>
              <div className="text-sm">{user?.location?.address}</div>
            </div>
          </div>
        </div>
        <div className="w-full !sticky bottom-0">
          <StyledBookAVisitButton
            isOpenSidebar={true}
            color="primary"
            size="small"
            onClick={handleLogoutClick}
            className="!m-0 w-full !text-sm"
          >
            Logout
          </StyledBookAVisitButton>
        </div>
      </div>
    </div>
  );
};

export default CallHospitalModal;
